//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import skuList from "./skuList";
import { query } from 'quill';
import treeComp from './tree';
export default {
	components: {
		treeComp,
	},
	props: [],
	data() {
		return {
			flag: 0,
			tabList: [{
				name: "全部商品",
				id: 0,
				val: 0,
			}, {
				name: "已上架",
				id: 10,
				val: 0,
			}, {
				name: "未上架",
				id: 20,
				val: 0,
			}],
			cascaderValue: "",
			// 搜索部分

			formInline: {
				productsName: '', //商品名称
				class: '', //商品分类
				brandId: '', //品牌
				supplierId: '',//供应商
				status: '',//供货方式
				threeClassId: "",
				twoClassId: "",
				oneClassId: "",
				modeOfSupply: "",
			},
			//tab栏部分
			flag: 0, //active默认
			allNums: 0,//全部商品
			trueCli: 0,//已上架
			falseCli: 0,//未上架
			//表格部分
			tableData: [],

			//分页部分
			pagination: {
				currentPage: 1,
				pageSize: 10,
				recordTotal: 5,
			},
			options: [],
			szEnterpriseInfoList: [],//供应商列表
			szProductsBrandList: [],//品牌列表
		};
	},

	mounted() {
		this.commodityList();
		this.classList();
		this.enterpriseInfoListData();
		this.brandNameListData();
	},
	methods: {
		brandNameListData() {
			var parsms = {
				pageNum: 1,
				pageSize: 999
			}
			this.$http.orders.brandNameList(parsms).then((res) => {
				this.szProductsBrandList = res.data.szProductsBrandList;


			});
		},
		enterpriseInfoListData() {
			var parsms = {
				pageNum: 1,
				pageSize: 999
			}

			this.$http.orders.enterpriseInfoList(parsms).then((res) => {
				this.szEnterpriseInfoList = res.data.szEnterpriseInfoList;

			});
		},
		handleChange(val) {
			console.log(val)
			if (val && val.length > 0) {
				this.formInline.oneClassId = val[0];
				this.formInline.twoClassId = val[1];
				this.formInline.threeClassId = val[2];
			}


		},
		classList() {
			this.$http.orders.classList().then((res) => {
				this.options = res.data;
				var arr = this.options;
				this.findChild(arr)


			});
		},

		findChild(array) {
			for (let i in array) {
				var data = array[i];
				if (data.szEnterpriseInfoList) {
					this.findChild(data.szEnterpriseInfoList)
					data.id = data.id.toString();
				} else {
					data.id = data.id.toString();

				}
			}
		},

		//商品列表
		commodityList() {
			var params = {
				pageNum: this.pagination.currentPage,
				pageSize: this.pagination.pageSize,
				status: this.formInline.status,
				productsName: this.formInline.productsName,
				modeOfSupply: this.formInline.modeOfSupply,
				threeClassId: this.formInline.threeClassId,
				twoClassId: this.formInline.twoClassId,
				oneClassId: this.formInline.oneClassId,
				brandId: this.formInline.brandId, //品牌
				supplierId: this.formInline.supplierId,//供应商
			}
			this.$http.orders.commodityList(params).then((res) => {
				console.log(res)
				this.tableData = res.data.szProductsSpuList;
				this.pagination.recordTotal = res.data.count;
				this.allNums = res.data.count;
				this.trueCli = res.data.upperShelf;
				this.falseCli = res.data.lowerShelf;
				this.tabList[0].val = Number(res.data.upperShelf + res.data.lowerShelf);
				this.tabList[1].val = res.data.upperShelf;
				this.tabList[2].val = res.data.lowerShelf;

				for (var i = 0; i < this.tableData.length; i++) {
					if (this.tableData[i].status == 10) {
						this.tableData[i].status = true;
					} else {
						this.tableData[i].status = false;
					}
				}

			});
		},
		uptStatusHandle(val) {
			console.log(val)
			var params = {
				id: val.id.toString(),
				status: val.status ? 10 : 20,
			}
			this.$http.orders.uptStatus(params).then((res) => {
				console.log(res)
				if (res.status == 1) {
					this.$message.success("修改成功");
					this.commodityList();
				}
			});

		},
		handleCurrentChange(val) {
			//分页
			this.pagination.currentPage = val;
			this.commodityList();
		},

		//查询

		onSubmit() {
			console.log(this.formInline)
			this.commodityList();
		},

		//清空

		handleReset() {
			this.formInline = {
				productsName: '', //商品名称
				class: '', //商品分类
				brandId: '', //品牌
				supplierId: '',//供应商
				status: '',//供货方式
				threeClassId: "",
				twoClassId: "",
				oneClassId: "",
				modeOfSupply: "",
			}

		},

		//查看操作

		lookDetail(val) {
			this.$router.push('./EnterDetail')
		},

		//修改操作

		amend(val) {
			console.log(val);
			this.$router.push({ path: './GoodsAmend', query: { ids: val.id } })
		},

		//全部商品

		allProduct(item, index) {
			this.flag = index;
			this.pagination.currentPage = 1
			if (index == 0) {
				this.formInline.status = '';
			} else {
				this.formInline.status = item.id;
			}

			this.commodityList();

		}
	},
};
